import './Header.css';

import Nav from '../../container/Nav';
import PropTypes from 'prop-types';
import React from 'react';
import Stepper from '../../elements/Stepper';
import checkinIcon from './assets/icon-header-checkin.svg';
import defaultIcon from './assets/icon-header-default.svg';
import engagementIcon from './assets/icon-header-engagement.svg';
import previewIcon from './assets/icon-header-preview.svg';
import projectIcon from './assets/icon-header-project.svg';
import projectsIcon from './assets/icon-header-projects.svg';
import { pure } from 'recompose';
import reportIcon from './assets/icon-header-report.svg';
import reviewIcon from './assets/icon-header-review.svg';
import SimpleMenu from '../../elements/SimplyMenu';
import Spinner from "../Snowflake/as/Spinner";

const getIcon = name => {
  switch (name) {
    case 'projects':
      return projectsIcon;
    case 'project':
      return projectIcon;
    case 'review':
      return reviewIcon;
    case 'checkin':
      return checkinIcon;
    case 'engagement':
      return engagementIcon;
    case 'preview':
      return previewIcon;
    case 'report':
      return reportIcon;
    default:
      return defaultIcon;
  }
};

const Header = ({ title, subtitle, steps, selectedStep, icon, locale, status }) => (
  <div className="header">
    <div className="title">
      <div className="icon">
        <a href={`/${locale}/`}>
          <img alt="" src={getIcon(icon)} />
        </a>
      </div>
      <div className="text">
        <h1>{title}</h1>
        <h2>{subtitle}</h2>
      </div>
    </div>
    <div className="progress">
      {steps ? <Stepper homeLink="/snowflake" locale={locale} /> : null}
    </div>
    {status && status.loading && (
      <div className="spinnerbox">
        <Spinner />
      </div>
    )}
      <Nav />
  </div>
);

Header.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  steps: PropTypes.array,
  selectedStep: PropTypes.number,
  icon: PropTypes.string,
  locale: PropTypes.string
};

Header.defaultProps = {
  selectedStep: 0,
  icon: 'default',
  locale: 'en-CA'
};

export default pure(Header);



// WEBPACK FOOTER //
// ./src/components/views/Header/index.js